import { setupFormState } from '@/components/form/tidal-form'
import { DeleteFormValues } from '../../../types'

export const initialValues: DeleteFormValues = {
  c1: false,
  c2: false,
  c3: false,
  c4: false,
}

export const form = setupFormState<DeleteFormValues>({
  id: 'companies-delete-form',
  initialValues,
})
